import http from '@/utils/http'


export function getQuickLinks(params){
    return http('/quick_links',{params})
}
export function getAnnouncements(params){
    return http('/announcements',{params})
}
export function getAnnouncementDetail(id){
    return http(`/announcements/${id}`)
}
export function readRequest(id){
    return http.post(`/announcements/${id}/read_request`)
}
export function replyOfferRequests(id,data){
    return http.post(`/announcements/${id}/reply_offer_requests`,data)
}